var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "hello screen-spacing" }, [
    _c("label", { staticClass: "me-2 h4", attrs: { for: "dropdown" } }, [
      _vm._v("Select Venue:"),
    ]),
    _c(
      "select",
      {
        staticClass: "form-select",
        attrs: { id: "dropdown" },
        on: {
          change: function ($event) {
            return _vm.updateVenue($event)
          },
        },
      },
      _vm._l(_vm.venueList, function (item, index) {
        return _c(
          "option",
          {
            key: index,
            staticClass: "card mx-3",
            domProps: { value: item._id },
          },
          [_vm._v(_vm._s(item.venue_name))]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }